<script setup lang="ts">
import AppBar from "./components/AppBar.vue";
import useToast, { setupToastBridge } from "@/components/Toaster";
import { takeCompanySwitchNotice } from "@/services/store";
import { useBreakpoint } from "@/helpers/useBreakpoint";
import EnvironmentBanner from "@/modules/root/components/EnvironmentBanner.vue";
import NavigationDrawer from "@/modules/root/components/NavigationDrawer.vue";
import { initializeNavigationDrawer } from "@/modules/root/app";
import { useSelectedTheme } from "./components/UseTheme";
import { useRoute } from "vue-router";
import { computed, onMounted } from "vue";
import { sv } from "@nuxt/ui/locale";

const breakpoint = useBreakpoint();
const { theme } = useSelectedTheme();
const route = useRoute();

const showNavigationDrawer = initializeNavigationDrawer(!breakpoint.value.mobile);
const shouldShowNavigation = computed(() => !route.meta.hideNavigation);
const shouldShowAppBar = computed(() => !route.meta.hideAppBar);

setupToastBridge();

// A company switch reloads the app; say where the user ended up once it's back.
const toast = useToast();
onMounted(() => {
  const companyName = takeCompanySwitchNotice();
  if (companyName) {
    toast.info(`Bytte till ${companyName}.`);
  }
});
</script>
<template>
  <UApp
    :locale="sv"
    :tooltip="{ delayDuration: 0 }"
    :toaster="{ position: 'bottom-right', duration: 8000, progress: false }"
  >
    <VApp :theme="theme">
      <EnvironmentBanner />
      <NavigationDrawer v-if="shouldShowNavigation" v-model="showNavigationDrawer" />
      <RouterView v-if="shouldShowAppBar" v-slot="{ Component }" name="appbar">
        <Transition name="router-fade" mode="out-in">
          <KeepAlive>
            <component :is="Component ?? AppBar" v-model:show-navigation-drawer="showNavigationDrawer" />
          </KeepAlive>
        </Transition>
      </RouterView>
      <VMain>
        <VContainer :fluid="breakpoint.mobile" max-width="1200" class="sm:p-6">
          <RouterView />
        </VContainer>
      </VMain>
    </VApp>
  </UApp>
</template>
